export function validateValidShippingPrice(so, isAdvanced) {
    if (
        so.type == null ||
        so.type === '' ||
        so.type === 'Takeaway' ||
        so.type === 'TakeawayOnly'
    ) {
        return null;
    }
    if (so.cost === null || so.cost === undefined) {
        return isAdvanced ? null : 'syi_validation_shipping_price_missing';
    }
    if (!isInt(so.cost)) {
        return 'syi_validation_shipping_amount_whole_number';
    }
    if (so.cost > 10000) {
        return 'syi_validation_shipping_max_price';
    }
    if (so.cost < 0) {
        return 'syi_validation_shipping_min_price';
    }
    return null;
}

function isInt(number) {
    return number % 1 === 0;
}
